export default __webpack_public_path__ + "static/media/ilustracao-homem-segurando-celular.2e60924f.svg";